import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaSoundcloud,
  FaTwitter,
  FaGlobe
} from 'react-icons/fa';

const SOCIAL_PLATFORMS = [
  { key: 'facebook', Icon: FaFacebook, label: 'Facebook' },
  { key: 'instagram', Icon: FaInstagram, label: 'Instagram' },
  { key: 'youtube', Icon: FaYoutube, label: 'YouTube' },
  { key: 'soundcloud', Icon: FaSoundcloud, label: 'SoundCloud' },
  { key: 'twitter', Icon: FaTwitter, label: 'Twitter' },
  { key: 'website', Icon: FaGlobe, label: 'Website' }
];

export const buildSocialLinks = (socialMedia = {}) =>
  SOCIAL_PLATFORMS
    .map(({ key, Icon, label }) => ({
      url: socialMedia[key],
      Icon,
      label
    }))
    .filter((link) => link.url && link.url.trim() !== '');
